<template>
  <div class="user-list">
    <div class="search-bar">
      <el-input v-model="searchParam.keyword_search" placeholder="输入分类名称" clearable @clear="getList"></el-input>

      <el-button type="primary" @click="getList('clear')">查询</el-button>
      <el-button v-if="isteacher" type="primary" @click="toDetail(0)">新增分类</el-button>
    </div>
    <div class="table">
      <el-table
        v-loading="loading"
        row-key="id"
        lazy
        :load="load"
        :tree-props="{
          children: 'children',
          hasChildren: 'hasChildren',
        }"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column prop="name" label="名称" fixed="left" width="320px" align="left"> </el-table-column>
        <el-table-column prop="num" label="数量" width="120px">
          <template slot-scope="scope">
            {{ scope.row.num }}
          </template></el-table-column
        >

        <el-table-column prop="is_show" label="是否显示" width="120px">
          <template slot-scope="scope">
            {{ ["隐藏", "显示"][scope.row.is_show] }}
          </template>
        </el-table-column>
        <el-table-column prop="create_at" label="创建时间"> </el-table-column>

        <el-table-column label="操作" fixed="right" width="480">
          <template slot-scope="scope">
            <el-button v-if="isteacher" class="mid-blue" :disabled="scope.row.level === 3" @click="toDetail(scope.row)"
              >添加下级分类</el-button
            >
            <el-button v-if="isteacher" class="mid-blue" @click="handleEditClick(scope.row)">编辑</el-button>
            <el-button v-if="isteacher" class="mid-blue" @click="handleEditClickTop(scope.row)">置顶</el-button>
            <el-button v-if="isteacher" class="mid-blue" @click="handleEditClickUp(scope.row)">上移</el-button>
            <el-button v-if="isteacher" class="mid-blue" @click="handleEditClickDown(scope.row)">下移</el-button>
            <el-button v-if="isteacher" class="mid-blue" @click="handleEditClickShow(scope.row)">{{
              scope.row.is_show ? "隐藏" : "显示"
            }}</el-button>
            <el-button v-if="isteacher" class="mid-red" @click="delItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-drawer
      ref="drawer"
      :title="editId ? '编辑分类' : '新建分类'"
      :visible.sync="showMdal"
      direction="rtl"
      custom-class="drawer"
    >
      <div class="drawer-content">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="分类名称" prop="name">
            <el-input v-model="form.name" autocomplete="off" />
          </el-form-item>

          <el-form-item label="菜单等级" prop="level">
            <el-select v-model="form.level" placeholder="请选择菜单等级" @change="getParentList">
              <el-option label="一级菜单" value="1" />
              <el-option label="二级菜单" value="2" />
              <el-option label="三级菜单" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.level !== '1'" label="上级菜单" prop="top_id">
            <el-select v-model="form.top_id" placeholder="请选择上级菜单">
              <el-option v-for="(value, key) in parentList" :key="key" :label="value.name" :value="value.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="显示" prop="is_show">
            <el-radio-group v-model="form.is_show">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="置顶" prop="top">
            <el-radio-group v-model="form.top">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="false" label="排序" prop="sort">
            <el-col :span="24">
              <el-input v-model="form.sort" placeholder="请输入数字，可不填" type="number"></el-input>
            </el-col>
            <el-col :span="24">
              <span>默认1000,越大越靠前</span>
            </el-col>
          </el-form-item>
        </el-form>
        <div class="drawer-footer">
          <el-button class="btn" @click="cancelForm">取 消</el-button>
          <el-button class="btn" type="primary" :loading="submitLoading" @click="onSubmitClick">{{
            submitLoading ? "提交中 ..." : "保 存"
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { paperCateList, delPaperCate, addPaperCate, editPaperCate, paperCateDetail } from "@/api/edu.js";
import Utils from "@/jslibs/utils";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      page_size: 10,
      loading: false,
      dates: [],
      teacherList: [],
      searchParam: {
        keyword_search: "",

        start_time: "",
        end_time: "",
      },
      tableData: [],
      listLoading: false,
      showMdal: false,
      form: {
        name: "",
        top_id: "",
        level: "",
        is_show: 1,
        top: 0,
      },
      list: [],
      parentList: {},
      editId: null,
      rules: {
        name: [
          {
            required: true,
            message: "请输入分类名称",
            trigger: "blur",
          },
          { min: 2, message: "长度在 2个字符以上", trigger: "blur" },
        ],

        level: [
          {
            required: true,
            message: "请选择等级",
            trigger: "change",
          },
        ],
        top_id: [
          {
            required: true,
            message: "请选择父级菜单",
            trigger: "change",
          },
        ],
      },
      submitLoading: false,
      addbox: false,
    };
  },
  computed: {
    isteacher() {
      const g = Utils.getCookie("X-Access-Group");
      return g != 927 && g != 952;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getDetail(row) {
      console.log(row);
      paperCateDetail(row.id).then((res) => {
        if (res && res.id) {
          this.form = { ...res };
          this.addbox = true;
        }
      });
    },
    changeTime(val) {
      this.searchParam.start_time = val ? val[0] : "";
      this.searchParam.end_time = val ? val[1] : "";
      if (!val) {
        this.getList();
      }
    },
    delItem(row) {
      this.$confirm("确定要删除该分类吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delPaperCate(row.id).then((res) => {
            if (res == true) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    toDistribution(row) {
      console.log(row);
      this.$router.push({
        path: "/distribution",
        query: row,
      });
    },
    toDetail(row) {
      console.log(row);
      if (this.$refs.form) this.$refs.form.resetFields();
      if (row === 0) {
        (this.form = {
          name: "",
          top_id: "",
          level: "1",
          is_show: 1,
          top: 0,
        }),
          (this.editId = null);
        this.showMdal = true;
      } else {
        // this.form.top_id = row.id;
        const level = row.level + 1;
        this.form.level = "" + level;
        const top_id = row.id;
        this.form.top_id = top_id;
        this.getParentList(level);
        this.showMdal = true;
      }

      return;
      this.$router.push({
        path: "/paper-cate-add",
        query: row,
      });
    },
    toSubDetail(e) {
      // 添加下级分类-传递分类id

      // var path = e.path

      const param = {
        tid: e.id,
        top_path: e.path,
        top_name: e.name,
      };
      this.$router.push({
        path: "/paper-cate-add",
        query: param,
      });
    },
    setTop(row) {},
    xiajia(row) {},
    agree() {},
    noagree(row) {
      this.$confirm("确定要拒绝该申请吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList(type) {
      if (type == "clear") {
        this.page_index = 1;
      }
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await paperCateList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
    async getParentList(type) {
      if (type === "1") {
        this.parentList = [];
        return false;
      }
      const param = {
        level: type - 1,
      };
      console.log(param);

      const result = await paperCateList(param);

      this.parentList = result;
      this.$forceUpdate();
    },
    load(tree, treeNode, resolve) {
      setTimeout(() => {
        resolve([
          {
            id: 31,
            date: "2016-05-01",
            name: "王小虎",
            address: "上海市普陀区金沙江路 1519 弄",
          },
          {
            id: 32,
            date: "2016-05-01",
            name: "王小虎",
            address: "上海市普陀区金沙江路 1519 弄",
          },
        ]);
      }, 1000);
    },
    cancelForm() {
      this.showMdal = false;
    },
    setDefault() {
      this.form = {
        name: "",
        top_id: "",
        level: "",
        is_show: 1,
        top: 0,
      };
    },
    handleEditClick(row) {
      this.setDefault();
      this.showMdal = true;
      if (this.$refs.form) this.$refs.form.resetFields();
      this.editId = row.id;
      const { name, top_id, level, is_show, top } = row;
      this.getParentList(level);
      this.form = {
        name,
        top_id,
        level,
        is_show,
        top,
      };
      this.form.level = "" + this.form.level;
      // this.form.top_id =  this.form.top_id
    },
    // 置顶
    handleEditClickTop(row) {
      this.submitLoading = true;
      row.top = 1;
      this.setDefault();
      // this.showMdal = true;
      if (this.$refs.form) this.$refs.form.resetFields();
      this.editId = row.id;
      const { name, top_id, level, is_show, top } = row;
      // this.getParentList(level);
      this.form = {
        name,
        top_id,
        level,
        is_show,
        top,
        id: row.id,
      };
      console.log(this.form);
      editPaperCate(this.form, row.id).then((res) => {
        console.log(res);
        this.submitLoading = false;
        this.$notify({ title: "操作成功", type: "success" });
        this.getList();
      });
    },
    // 隐藏
    handleEditClickShow(row) {
      this.submitLoading = true;
      row.is_show = 1 - row.is_show;
      this.setDefault();
      // this.showMdal = true;
      if (this.$refs.form) this.$refs.form.resetFields();
      this.editId = row.id;
      const { name, top_id, level, is_show, top } = row;
      // this.getParentList(level);
      this.form = {
        name,
        top_id,
        level,
        is_show,
        top,
        id: row.id,
      };
      console.log(this.form);
      editPaperCate(this.form, row.id).then((res) => {
        console.log(res);
        this.submitLoading = false;
        this.$notify({ title: "操作成功", type: "success" });
        this.getList();
      });
    },
    // 上移
    handleEditClickUp(row) {
      this.submitLoading = true;
      row.sort = 1 + row.sort;
      this.setDefault();
      // this.showMdal = true;
      if (this.$refs.form) this.$refs.form.resetFields();
      this.editId = row.id;
      const { name, top_id, level, is_show, top, sort } = row;
      // this.getParentList(level);
      this.form = {
        name,
        top_id,
        level,
        is_show,
        top,
        id: row.id,
        sort,
      };
      console.log(this.form);
      editPaperCate(this.form, row.id).then((res) => {
        console.log(res);
        this.submitLoading = false;
        this.$notify({ title: "操作成功", type: "success" });
        this.getList();
      });
    },
    // 下移
    handleEditClickDown(row) {
      this.submitLoading = true;
      row.sort = row.sort - 1;
      this.setDefault();
      // this.showMdal = true;
      if (this.$refs.form) this.$refs.form.resetFields();
      this.editId = row.id;
      const { name, top_id, level, is_show, top, sort } = row;
      // this.getParentList(level);
      this.form = {
        name,
        top_id,
        level,
        is_show,
        top,
        id: row.id,
        sort,
      };
      console.log(this.form);
      editPaperCate(this.form, row.id).then((res) => {
        console.log(res);
        this.submitLoading = false;
        this.$notify({ title: "操作成功", type: "success" });
        this.getList();
      });
    },

    onSubmitClick() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          const id = this.editId;
          const data = { ...this.form };
          if (!id) {
            await addPaperCate(data).catch((error) => {
              this.submitLoading = false;
              throw error;
            });
          } else {
            data.id = id;
            // console.log(this.form)
            await editPaperCate(data, data.id).catch((error) => {
              this.submitLoading = false;
              throw error;
            });
          }

          this.$notify({ title: "操作成功", type: "success" });
          this.getList("clear");
          this.editId = null;
          this.submitLoading = false;
          this.$refs.form.resetFields();
          this.$refs.drawer.closeDrawer();
        }
      });
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
.drawer-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;

  .drawer-footer {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    .btn {
      width: 50%;
    }
  }
  .el-select {
    width: 100%;
  }
  .el-table td,
  .el-table th {
    text-align: left !important;
  }
}
</style>
